// easeOutExpo: starts near full speed, decelerates sharply — feels snappy and physical
const ease = (t) => (t >= 1 ? 1 : 1 - Math.pow(2, -10 * t));

const scrollToTop = () => {
  const start = window.scrollY;
  if (!start) return;
  const startTime = performance.now();
  // sqrt scaling: perceived speed stays consistent regardless of distance
  const duration = Math.min(500, Math.max(180, Math.sqrt(start) * 8));
  const step = (now) => {
    const t = Math.min(1, (now - startTime) / duration);
    window.scrollTo(0, start * (1 - ease(t)));
    if (t < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
};

export default scrollToTop;
